import { confirmAlert } from 'react-confirm-alert'
import getText from '../../shared/i18n/labels'

// BUTTONS
import { BtnFill } from '../BtnFill'

export const titleColors = {
  ALERT: 'popup-title-alert',
  SUCCESS: 'popup-title-success',
  ERROR: 'popup-title-delete'
}

/**
 * PopupConfirm è un componente che mostra un popup di conferma con un titolo e contenuto personalizzati.
 *
 * @param {string} title - Il titolo del popup
 * @param {string} titleColor - Il colore del titolo
 * @param {string} innerHtml - L'HTML interno del popup
 * @param {string} text - Il testo sotto l'HTML interno
 * @param {boolean} showCancelButton - Se mostrare il pulsante di annullamento. Predefinito è false.
 * @param {boolean} showConfirmButton - Se mostrare il pulsante di conferma. Predefinito è false.
 * @param {string} cancel - Il testo del pulsante di annullamento. Predefinito è 'Annulla'.
 * @param {string} confirm - Il testo del pulsante di conferma. Predefinito è 'Continua'.
 * @param {function} onClickCancel - La funzione da chiamare quando il pulsante di annullamento viene cliccato
 * @param {function} handleClickConfirm - La funzione da chiamare quando il pulsante di conferma viene cliccato
 * @param {function} component - Il componente da rendere all'interno del popup
 */
export function PopupConfirm(props) {
  const Component = props.component || (() => <></>)

  const labels = getText(localStorage.getItem('language') || 'it')

  /**
   * confirm alert è una funzione di react-confirm-alert che mostra un popup
   *
   * @see https://github.com/GA-MO/react-confirm-alert
   *
   */
  return confirmAlert({
    /**
     * customUI è una funzione di callback che restituisce un elemento JSX per il contenuto del popup di conferma dell'avviso.
     *
     * La funzione riceve un oggetto con una singola proprietà, onClose, che è una funzione di callback che dovrebbe essere chiamata quando l'utente vuole chiudere il popup.
     * La funzione dovrebbe restituire un elemento JSX che verrà renderizzato all'interno del popup.
     *
     */
    customUI: ({ onClose }) => {
      return (
        <>
          <div className="bar"></div>
          <div className="popup popup-large modal-content">
            <div className="w-100 d-flex justify-content-end">
              <button type="button" className="close btn-close" onClick={onClose}>
                <span className="visually-hidden">Close</span>
              </button>
            </div>
            <div className={`row show-grid ${props.titleColor} text-center`}>
              <div className="col-12">
                <h5 className="fw-bold">{props.title || 'Attenzione'}</h5>
              </div>
            </div>
            <div className={'row show-grid text-center'}>
              <div className="col-12" dangerouslySetInnerHTML={{ __html: props.innerHtml }}></div>
              <div className="col-12">{props.text}</div>
              <div className="col-12">
                <Component />
              </div>
            </div>
            <div
              className={`pt-5 d-flex align-items-center ${props.showCancelButton !== false && props.showConfirmButton !== false ? 'justify-content-between' : 'justify-content-center'}`}>
              {props.showCancelButton !== false && (
                <button
                  type="button"
                  className="btn btn-outline-primary "
                  onClick={() => {
                    if (props.onClickCancel) props.onClickCancel()
                    onClose()
                  }}>
                  {props.cancel || labels.CANCEL}
                </button>
              )}
              {props.showConfirmButton !== false && (
                <BtnFill
                  text={props.confirm || labels.CONTINUE}
                  handlerOnClick={() => {
                    if (props.handleClickConfirm) props.handleClickConfirm()
                    onClose()
                  }}
                />
              )}
            </div>
          </div>
        </>
      )
    },
    closeOnClickOutside: false
  })
}
